import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
  Filter,
} from "react-bs-datatable";
import "../Pagination.css";
import {
  getBoxFolderOfEmps,
  deleteBoxFolderOfEmp,
  importExcel,
} from "../../../../services/BoxFolderOfEmpService";

// Define table headers
const headers = [
  { prop: "email", title: "Email", isSortable: true },
  { prop: "folderId", title: "Folder ID", isSortable: true },
  { prop: "actions", title: "Actions" },
];

const BoxFolderOfEmpList = () => {
  const navigate = useNavigate();
  const [folders, setFolders] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setMessage(""); // Clear previous messages
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await importExcel(formData);
      setMessage(response);
    } catch (error) {
      console.error("Upload error:", error);
      setMessage("Error uploading file.");
    }
  };

  useEffect(() => {
    getBoxFolderOfEmps()
      .then((data) => setFolders(data))
      .catch((error) => console.error(error));
  }, []);

  const handleDelete = (id) => {
    deleteBoxFolderOfEmp(id)
      .then(() => setFolders(folders.filter((folder) => folder._id !== id)))
      .catch((error) => console.error(error));
  };

  const customActions = (folder) => (
    <>
      <Link
        to={`/settings/box-folders/edit/${folder._id}`}
        className="waves-effect waves-circle btn btn-success btn-sm me-2"
      >
        <i className="ti ti-pencil"></i>
      </Link>
      <Button
        className="waves-effect waves-circle btn btn-danger btn-sm"
        onClick={() => handleDelete(folder._id)}
      >
        <i className="ti ti-trash"></i>
      </Button>
    </>
  );

  const data = folders.map((folder) => ({
    email: folder.email.toLowerCase(),
    folderId: folder.folderId,
    actions: customActions(folder),
  }));
  const filteredData = data.filter((item) =>
    item.email.toString().toLowerCase().includes(filterText.toLowerCase())
  );
  return (
    <div>
      <Card>
        <h1>Box Folders of Employees</h1>

        <Card.Body>
          <Row className="mb-4">
            <Col
              md={3}
              lg={3}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Form.Control
                type="text"
                placeholder="Search by Email"
                className="mb-3"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
            <Col md={7} lg={7}>
              <Form className="d-flex align-items-center">
                <Form.Group controlId="formFile" className="mb-0 mr-2">
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "inline-block", width: "auto" }}
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  onClick={handleUpload}
                  className="ml-2"
                  style={{ marginLeft: "5px", marginRight: "5px" }}
                >
                  Upload
                </Button>
                {message && (
                  <span className="" style={{ marginLeft: "10px" }}>
                    {message}
                  </span>
                )}
              </Form>
            </Col>
            <Col md={2} lg={2} className="d-flex justify-content-end">
              <Link to="/settings/box-folders/add">
                <Button variant="primary" className="mb-3">
                  Add Folder
                </Button>
              </Link>
            </Col>
          </Row>

          <DatatableWrapper
            body={filteredData}
            headers={headers}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15],
              },
            }}
          >
            <Table>
              <TableHeader />
              <TableBody />
            </Table>

            {/* Pagination Footer */}
            <Row>
              <Col className="d-flex flex-col justify-content-start">
                <PaginationOptions />
              </Col>

              <Col className="d-flex justify-content-end mt-4">
                <Pagination />
              </Col>
            </Row>
          </DatatableWrapper>
        </Card.Body>
      </Card>
    </div>
  );
};

export default BoxFolderOfEmpList;
